import { render } from "./NotesEnabled.vue?vue&type=template&id=1890f239&scoped=true"
import script from "./NotesEnabled.vue?vue&type=script&lang=js"
export * from "./NotesEnabled.vue?vue&type=script&lang=js"

import "./NotesEnabled.vue?vue&type=style&index=0&id=1890f239&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1890f239"]])

export default __exports__